import React from 'react'

export default React.createClass({
  componentDidMount () {
    var modal = document.querySelector('.ReactModal__Overlay')
    if (modal) modal.scrollTop = 0
  },

  render () {
    return null
  }
})



// WEBPACK FOOTER //
// ./src/components/helpers/ModalScrollTop.js